import { map, mergeMap } from "rxjs/operators";
import { SubscriptionChangeStartRequest } from "../models/subscriptions/subscription-change-start-request.model";
import { PaymentsRepositoryService } from "./payments-repository.service";
import { SubscriptionChangeStartResult } from "../models/subscriptions/subscription-change-start-result.model";
import { DwModalButtonStandardConfigs, DwModalConfig, DwModalResult, DwModalService, DwModalSize } from "@devwareapps/devware-cap";
import { Observable } from "rxjs";
import { ChangeSchoolSubscriptionModalComponent } from "../components/change-school-subscription-modal/change-school-subscription-modal.component";
import { SubscriptionChangeUIActions } from "../models/subscriptions/subscription-change-ui-actions.enum";
import { Injectable } from "@angular/core";
import { SubscriptionChangeCompleteRequest } from "../models/subscriptions/subscription-change-complete-request.model";
import { SubscriptionChangeCompleteResult } from "../models/subscriptions/subscription-change-complete-result.model";

@Injectable({ providedIn: 'root' })
export class SubscriptionManagerService {
    constructor(private paymentsRepositoryService: PaymentsRepositoryService, private dwModalService: DwModalService) {

    }

    public startSubscriptionChange(existingSubscriptionId: number, newSubscriptionTierId: number): Observable<DwModalResult<SubscriptionChangeCompleteResult>> {
        const request: SubscriptionChangeStartRequest = {
            subscriptionId: existingSubscriptionId,
            subscriptionTierId: newSubscriptionTierId,
            discountCode: null, // Can remove since it will be on the current subscription
        };

        return this.paymentsRepositoryService.subscriptionChangeStart(request)
            .pipe(mergeMap((result) => {
                return this.showSubscriptionChangeModal(result);
            }));
    }

    private showSubscriptionChangeModal(subscriptionChangeStartResult: SubscriptionChangeStartResult): Observable<DwModalResult> {
        let modalConfig = new DwModalConfig<SubscriptionChangeStartResult>();
        
        modalConfig.title = 'Change Subscription';

        modalConfig.buttons = DwModalButtonStandardConfigs.instance.okAndClose;
        
        switch(subscriptionChangeStartResult.SubscriptionChangeUIAction) {
            case SubscriptionChangeUIActions.none:
                modalConfig.buttons = [DwModalButtonStandardConfigs.instance.okButton];
                break;
            case SubscriptionChangeUIActions.downgradeSubscriptionVerify:
                modalConfig.title = 'Downgrade Subscription';
                break;
            case SubscriptionChangeUIActions.updateSubscriptionNoInvoice:
                modalConfig.title = 'Upgrade Subscription';
                break;
            default:
                
                break;
        }

        modalConfig.data = subscriptionChangeStartResult;
        modalConfig.allowFullScreen = true;
        modalConfig.modalSize = DwModalSize.medium;

        // modalConfig.customModalWidth = '400px';
        // modalConfig.customModalHeight = '300px';

        modalConfig.component = ChangeSchoolSubscriptionModalComponent; // Assuming you have a component for this modal

        return this.dwModalService.showModal<any, any>(modalConfig);
    }
}